module.exports = __webpack_public_path__ + "img/20201214172923319.874c48ca.jpg";